export default {
  component: {
    LOGOUT_POPUP: 'logout_popup',
    COMPANY_SECTION: 'company_section',
    LOGIN: 'login',
    LANDING_HEADER: 'landing_header',
    SECTION_LIST: 'section_list',
    SETTINGS: 'settings',
    ORDER_HISTORY: 'order_history',
    CHOOSE_PERIOD_INTERVAL: 'choose_period_interval',
    ORDER_LIST: 'order_list',
    CHECKOUT: 'checkout',
    QUOTAION_TERMS_AND_CONDITIONS: 'term_condition',
    THANK_YOU_PAGE: 'thankyou',
    IMEI_DETAIL: 'sale_detail'
  },
  label: {
    LOGIN: 'Login',
    REGISTER: 'Register',
    FORGET_PASSWORD: 'Forget Password',
    TERM_AND_CONDITION: 'Term & Condition',
    PRIVACY_POLICY: 'Privacy Policy',
    LOGOUT: 'Logout',
    BACK: 'Back',
    REDEEM_POINT: 'Redeem Point',
    SEE_MISSION: 'See Mission',
    SETTINGS: 'Setting',
    ALLOCATE_POINT: 'Tukar Poin',
    VIEW_MISSION: 'Lihat Misi',
    VIEW_QUOTATION_DETAIL: 'Lihat Rincian',
    CASHBACK: {
      CLAIM: 'Klaim'
    },
    SECTION: {
      companyInfo: 'Company Info',
      businessEntityRep: 'Director Info',
      companyPIC: 'PIC Info',
      legalDocuments: 'Legal Document',
      registrationDocuments: 'Registration Form'
    },
    DOWNLOAD: 'Download',
    ORDER_STATUS: {
      QUOTATION_CREATED: 'Diproses',
      QUOTATION_PROCESSED: 'Menunggu persetujuan',
      QUOTATION_REJECTED: 'Ditolak',
      QUOTATION_EXPIRED: 'Kedaluwarsa',
      QUOTATION_APPROVED: 'Disetujui',
      PO_CREATED: 'Disetujui',
      IN_PACKING: 'Dalam pengemasan',
      IN_DELIVERY: 'Dalam pengiriman',
      DELIVERED: 'Sampai',
      ORDER_COMPLETED: 'Selesai'
    },
    LIST_ALL_DATA: 'Semua',
    CHANGE_ADDRESS: {
      EDIT: 'Ubah alamat',
      CANCEL: 'Kembali',
      SAVE: 'Simpan'
    },
    PROCEED_CHECKOUT: 'Ajukan',
    SHOW_CONFIRMATION_POPUP: {
      CHECKED: 'Checked',
      UNCHECKED: 'Unchecked'
    },
    THANK_YOU: {
      CONTINUE: 'Belanja lagi',
      CHECK: 'Cek status pesanan'
    }
  },
  error_type: {
    ERROR_TYPE_HANDLE_UNSPECIFIED: 'unspecified',
    ERROR_TYPE_HANDLE: '1'
  },
  origin_screen: {
    landingPage: 'dealer-landing',
    login: 'dealer-login',
    settings: 'dealer-setting',
    order: 'dealer-order',
    home: 'dealer-homepage',
    checkout: 'dealer-checkout',
    thankYouPage: 'dealer-thank-you',
    rewardsDetail: 'dealer-sale'
  }
}
